module.exports = __webpack_public_path__ + "static/media/cal-grey-outline.2553f06c.svg";